<div class="wrap">

    <div class="margin-large-bottom-res margin-large-top-res">
        <ul class="uk-flex-center" uk-tab>
            <li class="uk-active">
                <a>
                    Véhicules
                </a>
            </li>
            <li>
                <a [routerLink]="['/ressource/station/list']">
                    Stations
                </a>
            </li>
        </ul>
    </div>

    <div class="uk-form-stacked">

        <div class="uk-margin uk-display-inline-block research-form-controls search">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <button class="uk-form-icon uk-form-icon-flip pointer" type="submit"
                    style="border: none; background: inherit;">
                    <img src="../../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
                </button>
                <input class="search-bar" type="text" [(ngModel)]="search" (ngModelChange)="onSearchChange($event)"
                    placeholder="Rechercher">
            </div>
        </div>

        <button class="button bold button-align uk-display-inline-block uk-float-right uk-margin-left uk-margin-bottom"
            *ngIf="session.role.ability === 'super-admin' || session.role.ability === 'admin'" uk-toggle="target: #add-vehicle" type="button">
            <span>Nouveau véhicule</span>
            <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="back" class="uk-margin-left">
        </button>

        <button class="button bold button-align uk-display-inline-block uk-float-right uk-margin-bottom"
            (click)="exportDataAsXLSX()" type="button">
            <span *ngIf="excelLoading === false">
                <span class="vertical-align-middle">Export</span>
                <img src="../../../../assets/icons/Export.svg" width="32px" height="32px" alt="user"
                    class="uk-margin-left" />
            </span>
            <span *ngIf="excelLoading === true">
                <div uk-spinner class="loading-small-button"></div>
            </span>
        </button>

    </div>

    <div *ngIf="loadingStatus === false && noResult === false" class="uk-width-1-1@s uk-align-center uk-display-inline-block">
        <div class="uk-form-controls uk-display-inline-block uk-margin-small-right">
            <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="filtre === 0"
                (click)="changeFiltre(0)">
                Tout
            </button>
        </div>
        <div class="uk-form-controls uk-display-inline-block uk-margin-small-right">
            <button class="uk-button bg-color-red round-button uk-display-inline-block@m"
                [class.round-button-toggle-green]="filtre === 1" (click)="changeFiltre(1)">
                Activé
            </button>
        </div>
        <div class="uk-form-controls uk-display-inline-block">
            <button class="uk-button round-button uk-display-inline-block@m"
                [class.round-button-toggle-red]="filtre === 2" (click)="changeFiltre(2)">
                Désactivé
            </button>
        </div>
    </div>

    <div *ngIf="noResult === true" class="bold uk-margin-medium-top">
        Vous n'avez pas de véhicules.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loadingStatus === false && noResult === false" style="margin-top: 50px;">

        <div *ngIf="session.role.ability === 'admin'" uk-grid class="uk-grid-small">

            <div *ngIf="vehicles.length === 0" class="bold uk-width-1-1">
                <div>Aucun élément trouvé</div>
            </div>

            <div *ngFor="let vehicle of vehicles; let i = index" class="uk-width-1-2@m uk-width-1-1">
                <a href="#"
                    class="uk-card card hover card-border vehicle-card uk-padding-remove color-cold-grey pointer"
                    [routerLink]="['/ressource/vehicle/informations', vehicle.id]" uk-grid
                    style="margin-left: 0px; padding: 7px !important;">

                    <div class="uk-width-3-10 uk-padding-remove img-wrap uk-visible@s">
                        <img [src]="vehicle.vehiclePicture"
                            onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';">
                    </div>

                    <div class="uk-width-7-10" style="padding: 7px 20px 7px 20px;">
                        <span class="uk-card-title light" style="font-size: 32px;">{{ vehicle.name }}</span><br>
                        <span class="bold uk-text-uppercase small-offset" style="font-size: 17px;">{{ vehicle.brand
                            }}</span><br>
                        <span class="light" style="font-size: 17px;">{{ vehicle.model }}</span>
                    </div>

                    <div class="uk-float-right">
                        <img class="uk-position-absolute vertical-align" style="right: 10px;"
                            src="../../../assets/icons/TRIANGLE Right.svg" width="48px" height="48px" alt="user" />
                    </div>
                </a>
            </div>

        </div>

        <div *ngIf="session.role.ability === 'super-admin'" uk-grid
            class="remove-grid-ml-pl uk-margin-remove-top uk-width-1-1">

            <div *ngIf="vehicles.length === 0" class="bold uk-width-1-1">
                <div>Aucun élément trouvé</div>
            </div>

            <a href="#" uk-grid *ngFor="let vehicle of vehicles; let i = index"
                class="uk-width-1-1 item-list alt color-grey remove-grid-ml-pl pointer"
                [routerLink]="['/ressource/vehicle/informations', vehicle.id]">
                <div class="uk-visible@m uk-width-1-12 item-column">
                    <img class="uk-position-absolute" style="left: 10px;" src="../../../assets/icons/Vehicle.svg"
                        width="48px" height="48px" alt="adherent" />
                </div>
                <div class="uk-width-3-12 item-column bold" style="font-size: 15px;">
                    <span>{{ vehicle.name }}</span>
                </div>
                <div class="uk-width-3-12 item-column regular brandvehicle" style="font-size: 15px;">
                    <span>{{ vehicle.brand }}</span>
                </div>
                <div class="uk-width-3-12 item-column regular modelvehicle" style="font-size: 15px;">
                    <span>{{ vehicle.model }}</span>
                </div>

                <div class="uk-align-center" *ngIf="filtre === 0">
                    <span class="material-icons vertical-align-middle"
                        [class.color-green]="vehicle.idDisabledVehicle === 0"
                        [class.color-red]="vehicle.idDisabledVehicle > 0">fiber_manual_record</span>
                </div>
                <div class="uk-width-expand item-column"></div>
                <div class="uk-align-center">
                    <span class="color-cold-red bold uk-width-1-1 uk-text-uppercase"
                        uk-tooltip="Déconnecter depuis plus de 6 heures" *ngIf="vehicle.connection == 0">
                        <span class="material-icons color-red">wifi_off</span>
                    </span>
                    <span class="color-cold-orange bold uk-width-1-1 uk-text-uppercase"
                        uk-tooltip="Déconnecter depuis plus de 3 heures" *ngIf="vehicle.connection == 1">
                        <span class="material-icons color-orange">wifi</span>
                    </span>
                    <span class="color-cold-grey bold uk-width-1-1 uk-text-uppercase"
                        uk-tooltip="Der. connexion moins de 3 heures" *ngIf="vehicle.connection == 2">
                        <span class="material-icons color-green">wifi</span>
                    </span>
                </div>

                <div class="uk-width-expand item-column"></div>
                <div class="uk-width-1-12 item-column">
                    <div class="arrow-button">
                        <img src="../../../assets/icons/ArrowRight.svg" width="30px" height="30px" alt="user" />
                    </div>
                </div>
            </a>
        </div>


        <div class="uk-margin-large" *ngIf="maxPages === 0"></div>

        <div class="uk-position-relative uk-width-1-1 uk-padding uk-margin" *ngIf="maxPages > 0">
            <div class="uk-position-center">
                <button [disabled]="currentPage === 1" class="uk-button button" (click)="prevPage()">Précédent</button>
                <div class="uk-display-inline-block" *ngFor="let item of [].constructor(maxPages); let i = index;">
                    <div *ngIf="currentPage === i + 1" class="bold uk-margin-left vop-blue">{{i + 1}}</div>
                    <div *ngIf="currentPage !== i + 1" class="uk-margin-left pointer vop-blue" (click)="goPage(i + 1)">
                        {{i + 1}}</div>
                </div>
                <button [disabled]="currentPage === maxPages" class="uk-button button uk-margin-left"
                    (click)="nextPage()">Suivant</button>
            </div>
        </div>
    </div>

</div>

<app-add-vehicle (changed)="updateVehicles()"></app-add-vehicle>